var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Info/i icon")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.9166667,52.4166667 L40.0833333,52.4166667 L40.0833333,33.9166667 L33.9166667,33.9166667 L33.9166667,52.4166667 Z M37,6.16666667 C19.98,6.16666667 6.16666667,19.98 6.16666667,37 C6.16666667,54.02 19.98,67.8333333 37,67.8333333 C54.02,67.8333333 67.8333333,54.02 67.8333333,37 C67.8333333,19.98 54.02,6.16666667 37,6.16666667 Z M37,61.6666667 C23.4025,61.6666667 12.3333333,50.5975 12.3333333,37 C12.3333333,23.4025 23.4025,12.3333333 37,12.3333333 C50.5975,12.3333333 61.6666667,23.4025 61.6666667,37 C61.6666667,50.5975 50.5975,61.6666667 37,61.6666667 Z M33.9166667,27.75 L40.0833333,27.75 L40.0833333,21.5833333 L33.9166667,21.5833333 L33.9166667,27.75 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9997-Saved-out-assets",
    transform: "translate(-1564.000000, -596.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/dashboard_24px",
    transform: "translate(1558.000000, 590.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/info_outline_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.69197dd5e98a69da2e90c904be82850a.svg";
export { ForwardRef as ReactComponent };